	<div *ngIf="isloading">
			<div class="loader"></div>
		</div>


// WEBPACK FOOTER //
// ./src/app/loader-page/loader-page.component.html